import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import type { CrossAppBridge, CrossAppBridgeEvent } from './cross-app-bridge';

/** In-memory bridge stand-in until BroadcastChannel / SharedWorker / server transport lands. */
@Injectable({ providedIn: 'root' })
export class MockCrossAppBridge implements CrossAppBridge {
  private readonly eventsSubject = new Subject<CrossAppBridgeEvent>();
  readonly events$: Observable<CrossAppBridgeEvent> = this.eventsSubject.asObservable();

  emit(event: CrossAppBridgeEvent): void {
    this.eventsSubject.next(event);
  }
}
